import { useTranslation } from 'react-i18next'
import Sheet from './Sheet'
import ActionBar from './ActionBar'
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { STAFF } from '../constants';


export default function SelectStaff(props) {
    const {
      selectedStaff,
      selectStaff,
      showChangeStaff,
      setShowChangeStaff,
      location
    } = props;
    const { t } = useTranslation();

    return (
        <Sheet
            open={showChangeStaff}
            onClose={() => setShowChangeStaff(false)}
            title={t('common.selectStaff.title')}
            actions={<ActionBar cancel={{ label: t('common.cancel'), onClick: () => setShowChangeStaff(false) }} />}
        >
            <FormControl fullWidth variant="outlined">
                <InputLabel id="staff-label">{t('common.selectStaff.label')}</InputLabel>
                <Select
                    fullWidth
                    id="staff"
                    labelId="staff-label"
                    value={selectedStaff || ''}
                    label={t('common.selectStaff.label')}
                    onChange={e => selectStaff(e.target.value)}
                    >
                      {Object.keys(STAFF[location]).map(staff => (
                        <MenuItem key={staff} value={staff}>{staff}</MenuItem>
                      ))}
                </Select>
            </FormControl>
        </Sheet>
    )
}
